import { createFileRoute, redirect } from "@tanstack/react-router";

/** Team detail moved with the teams list into the organization settings. */
export const Route = createFileRoute("/_authenticated/dashboard/teams/$teamId")(
	{
		beforeLoad: ({ params }) => {
			throw redirect({
				to: "/settings/teams/$teamId",
				params: { teamId: params.teamId },
			});
		},
	},
);
